import { AnimatePresence } from 'framer-motion';

/**
 * This component is essentially just a wrapper around AnimatePresence. The className
 * below isn't used currently, but could be if needed
 *
 * Motion components beneath this will animate when the page loads, and
 * follow the rules of exitBeforeEnter
 */
const PageAnimation = ({ children }) => (
  <div className="page-transition">
    <AnimatePresence
      initial
      mode="wait"
    >
      {children}
    </AnimatePresence>
  </div>
);

export default PageAnimation;
